module.exports = __webpack_public_path__ + "img/typography-green.005e49bd.png";